<div class="d-flex p-4 justify-content-between"
     [formGroup]="serviceFormGroup">
  <div class="form">
    <div class="form-group">
      <label required>Service Name</label>
      <input type="text"
             formControlName="name"
             class="form-control"
             placeholder="Service Name">
    </div>
    <div class="form-group">
      <label required>Category</label>
      <select class="form-control"
              formControlName="category_id">
        <option selected
                disabled
                value="">Select Category</option>
        <option *ngFor="let item of (categories$|async)"
                [value]="item.id">{{item.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="name"
             required>Country</label>
      <select class="form-control"
              formControlName="country_id"
              id="country"
              aria-describedby="producthelp">
        <option *ngFor="let country of countries$|async"
                [value]="country.id">
          {{ country.country }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label required>Service Provider</label>
      <select class="form-control"
              formControlName="service_provider_id">
        <option selected
                disabled
                value="">Select Service Provider</option>
        <option *ngFor="let item of serviceProviders$|async"
                [value]="item.id">{{item.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <label required>Unit of charge</label>
      <small class="form-text text-muted">Units used to measure and charge for this service e.g. Acres</small>
      <select class="form-control"
              formControlName="unit_of_measure_id">
        <option selected
                disabled
                value="">Select Unit of Charge</option>
        <option *ngFor="let item of unitsOfMeasure$|async"
                [value]="item.id">{{item.singular|titlecase}}-{{item.plural|titlecase}}</option>
      </select>
      <small>
        <a routerLink="unit-of-charge"
           class="text-primary text-decoration-underline">Add Unit</a>
      </small>
    </div>

    <div class="form-group">
      <label required>Search Tags</label>
      <small class="form-text text-muted">Tags searches related to this service (Comma separated)</small>
      <app-editor [tags]="tagsControl.value"
                  placeholder="Enter Tags"
                  [tagsControl]='tagsControl'
                  aria-describedby="tagshelp"></app-editor>
      <small id="tagshelp"
             class="form-text text-muted">Press the *spacebar* or *comma* after every tag
        entered</small>
    </div>
    <div class="form-group">
      <label required>Show Discount</label>
      <small class="form-text text-muted">Display this service as discounted</small>
      <div class="form-row">
        <div class="col-3">
          <select class="form-control"
                  formControlName="show_discount">
            <option [value]="false">No</option>
            <option [value]="true">Yes</option>
          </select>
        </div>
        <div class="col-3">
          <input type="number"
                 formControlName="discount_rate"
                 class="form-control"
                 placeholder="0%">
        </div>
      </div>
    </div>
  </div>
  <div>
    <app-service-action-bar></app-service-action-bar>
  </div>
</div>
<router-outlet></router-outlet>
